import { firebaseApp } from "./config/firebase";

const RELEASE = "8cc54f-stability1";
const clean = (value: unknown) => String(value instanceof Error ? value.message : value || "Unknown client error").replace(/https?:\/\/\S+/g, "[url]").slice(0, 180);

export function initializeProductionTelemetry() {
  if (!import.meta.env.PROD || !firebaseApp || !import.meta.env.VITE_FIREBASE_MEASUREMENT_ID) return;
  const start = () => void Promise.all([import("firebase/analytics"), import("firebase/performance")]).then(async ([analyticsSdk, performanceSdk]) => {
    if (!(await analyticsSdk.isSupported())) return;
    const analytics = analyticsSdk.getAnalytics(firebaseApp!);
    performanceSdk.getPerformance(firebaseApp!);
    analyticsSdk.logEvent(analytics, "app_open", { release: RELEASE });

    const report = (source: string, value: unknown, fatal = false) => analyticsSdk.logEvent(analytics, "exception", {
      description: clean(value),
      source,
      fatal,
      release: RELEASE,
    });
    window.addEventListener("error", (event) => report("window.error", event.error || event.message));
    window.addEventListener("unhandledrejection", (event) => report("unhandledrejection", event.reason));
    window.addEventListener("rw:share-event", (event) => {
      const detail = (event as CustomEvent<{ stage?: string; source?: string; error?: string }>).detail || {};
      analyticsSdk.logEvent(analytics, "share_flow", {
        stage: clean(detail.stage || "unknown"),
        source: clean(detail.source || "unknown"),
        error: detail.error ? clean(detail.error) : "",
        release: RELEASE,
      });
    });
    window.addEventListener("rw:runtime-error", (event) => {
      const detail = (event as CustomEvent<{ message?: string; mode?: string }>).detail || {};
      report(`runtime.${clean(detail.mode || "unknown")}`, detail.message || "Unknown runtime error");
    });

    if ("PerformanceObserver" in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) analyticsSdk.logEvent(analytics, "web_vital", {
            metric: entry.entryType,
            value_ms: Math.round(entry.duration || entry.startTime),
            release: RELEASE,
          });
        });
        observer.observe({ type: "largest-contentful-paint", buffered: true });
      } catch { /* Browser does not expose this performance entry type. */ }
    }
  }).catch((error) => console.warn("Production telemetry could not start.", error));
  window.setTimeout(start, 1200);
}
